module.exports = __webpack_public_path__ + "static/4-aaf780005f75218f4aa6987a969c6b1e.jpg";